module.exports = __webpack_public_path__ + "static/media/hue2.46b2e230.png";